import { match, P } from 'ts-pattern';
import { Pill, type PillProps, type PillVariant } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation';
import { IxcCorpactionsV1ActionType } from '@interxfi/types';

interface CorpactActionTypePillProps extends Omit<PillProps, 'children' | 'variant'> {
  actionType: IxcCorpactionsV1ActionType | undefined;
}

export function CorpactActionTypePill({ actionType, isPending, ...rest }: CorpactActionTypePillProps) {
  return (
    <Pill
      isPending={!actionType || isPending}
      variant={match(actionType)
        .returnType<PillVariant>()
        .with(P.union(IxcCorpactionsV1ActionType.StockSplit, IxcCorpactionsV1ActionType.ReverseStockSplit), () => 'primary')
        .with(IxcCorpactionsV1ActionType.Spinoff, () => 'secondary')
        .with(IxcCorpactionsV1ActionType.Merger, () => 'tertiary')
        .with(P.union(IxcCorpactionsV1ActionType.Dividend, IxcCorpactionsV1ActionType.StockDividend), () => 'quaternary')
        .with(P.union(undefined, IxcCorpactionsV1ActionType.Unspecified), () => 'neutral')
        .exhaustive(() => 'neutral')}
      {...rest}
    >
      <TranslatedText
        defaultValue={actionType}
        i18nKey={{ namespace: 'ixcCorpactionsV1', enumName: 'IxcCorpactionsV1ActionType', value: actionType }}
      />
    </Pill>
  );
}
